import { Flex, Link, Paragraph, Popover } from "@eworkit/iris";
import React, { FC } from "react";
import { PopoverState } from "reakit";

import { LazyUserAvatar } from "@/components/avatars";
import { UserBase } from "@/data/users";

export interface UserPopoverProps {
  user: UserBase;
  state: PopoverState;
  position?: string | null;
}

export const UserPopover: FC<UserPopoverProps> = ({ user, state, position }) => {
  return (
    <Popover data-test="popover" popoverState={state} sx={{ zIndex: "tooltip" }}>
      <Flex gap="xs" p="md">
        <LazyUserAvatar user={user} />
        <Flex flexDirection="column" gap="xs">
          <Flex flexDirection="column">
            <Paragraph data-test="popover-fullName" size="p-lg" bold>
              {user.firstName} {user.lastName}
            </Paragraph>
            {position && (
              <Paragraph data-test="popover-positionName" size="p-md" color="n700">
                {position}
              </Paragraph>
            )}
          </Flex>
          <Flex flexDirection="column">
            {user.phone && (
              <Paragraph data-test="popover-phone" size="p-md" color="n700">
                {user.phone.phonePrefix} {user.phone.phoneNumber}
              </Paragraph>
            )}

            {user.email && (
              <Paragraph size="p-md">
                <Link data-test="popover-email" href={`mailto:${user.email}`}>
                  {user.email}
                </Link>
              </Paragraph>
            )}
          </Flex>
        </Flex>
      </Flex>
    </Popover>
  );
};
